import { PickersDay, PickersDayProps } from "@mui/x-date-pickers";
import { shiftTypeColorMap } from "./types";
import { useShiftInviteContext } from "./Context/shiftInviteContext";

type GroupInviteDayPickerProps = PickersDayProps<Date> & {
  selectedDate?: Date;
};

export function GroupShiftInviteDayPicker(props: GroupInviteDayPickerProps) {
  const { selectedDate, day, ...otherProps } = props;
  const { multipleShiftInfo } = useShiftInviteContext();

  const highlightedDayShiftTypesMap = [...multipleShiftInfo.values()].reduce((map, shiftInfo) => {
    const selectedDayISO = shiftInfo.selectedDate?.toISOString() ?? "";
    map.set(selectedDayISO, [...(map.get(selectedDayISO) ?? []), shiftInfo.name]);
    return map;
  }, new Map<string, string[]>());
  const selected = [...highlightedDayShiftTypesMap.keys()].some((selectedDay) => {
    return selectedDay === day.toISOString();
  });
  const selectedShiftTypes = [...(highlightedDayShiftTypesMap.get(day.toISOString()) ?? [])];
  const isCurrentSelectedDay = day.toISOString() === selectedDate?.toISOString();

  return (
    <PickersDay
      {...otherProps}
      day={day}
      selected={selected}
      sx={{
        background: (theme) => {
          if (selectedShiftTypes.length === 0 || !selected) {
            return "";
          }
          if (selectedShiftTypes.length === 1) {
            return `${theme.palette[shiftTypeColorMap[selectedShiftTypes[0]]].light} !important`;
          }
          if (selectedShiftTypes.length === 2) {
            return `linear-gradient(to right, ${
              theme.palette[shiftTypeColorMap[selectedShiftTypes[0]]].light
            } 50%, ${theme.palette[shiftTypeColorMap[selectedShiftTypes[1]]].light} 50%)`;
          }
          return `conic-gradient(${
            theme.palette[shiftTypeColorMap[selectedShiftTypes[0]]].light
          } 33%, ${theme.palette[shiftTypeColorMap[selectedShiftTypes[1]]].light} 33%, ${
            theme.palette[shiftTypeColorMap[selectedShiftTypes[1]]].light
          } 67%, ${theme.palette[shiftTypeColorMap[selectedShiftTypes[2]]].light} 67%)`;
        },
        border: isCurrentSelectedDay ? "2px solid #000" : "",
      }}
    />
  );
}
